import { render, staticRenderFns } from "./new-instance-modal.component.vue?vue&type=template&id=72322ef8&scoped=true"
import script from "./new-instance-modal.component.vue?vue&type=script&lang=ts"
export * from "./new-instance-modal.component.vue?vue&type=script&lang=ts"
import style0 from "./new-instance-modal.component.vue?vue&type=style&index=0&id=72322ef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72322ef8",
  null
  
)

export default component.exports